import { statusStaff } from '../../../../client/events/_utils/statusCandidate'

export const dataStatusCandidacyOptions = [
  ...Object.entries(statusStaff).map((item) => {
    return { label: `${item[0]} - ${item[1].status}`, value: item[0] }
  }),
]
